<template>
  <v-container fluid style="padding: 0 16px 0 16px;">
    <!-- User List Drawer -->
    <v-skeleton-loader v-if="reponseHeigth" :loading="!flagNav" transition="scale-transition" max-height="64"
      type="table-heading">
      <v-toolbar class="header-title" v-if="reponseHeigth">
        <v-toolbar-title class="title">{{ $t('_ChatService') }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
    </v-skeleton-loader>

    <v-row style="margin-top: 2rem;">
      <v-col v-if="reponseWidth || !showUserList" cols="12" class="pt-0 pb-4">
        <ChannelTabs :tabs="tabSocialType" :model-value="currentIndex" :get-logo="getLogo" :get-color="getSocialColor" :dense="denseTabs" @update:modelValue="onTabChange" />
      </v-col>
      <v-col v-if="showUserList && reponseWidth" :cols="listCols" class="flex-grow-1 flex-shrink-0 pt-0">
        <div class="overflow-y-hidden fill-height view-height" style="display: flex;flex-direction: column;
          height: 100% !important;">
          <v-card class="d-flex flex-column pa-0"
            style="border: 1px solid #e0e0e0; border-radius: 15px; height: 100%;box-shadow: none;">
            <v-card-title class="d-flex justify-center align-center" style="padding-bottom: 0px !important;">
              <span style="font-size: 16px; font-weight: 600;">{{ $t('allChats') }} <span style="font-weight: 400; color: #171717;">({{ totalchats }})</span></span>
              <v-spacer />
              <div class="chatservice-header-actions">
                <v-btn
                  variant="outlined"
                  class="notification-clear-btn"
                  :loading="bulkClearLoading"
                  :disabled="bulkClearLoading"
                  @click.stop="clearTopicNotifications"
                >
                  {{ $t('notificationClear') }}
                  <v-tooltip activator="parent" location="top" width="220">
                    {{ $t('_markUnreadAsRead') }}
                  </v-tooltip>
                </v-btn>

                <v-menu location="bottom start" min-width="300" :close-on-content-click="false" v-model="menuOpenFull">
                  <template v-slot:activator="{ props }">
                    <v-btn icon variant="text" v-bind="props" class="optionbtn">
                      <v-icon style="cursor: pointer;"
                        :color="NavbarBtnColorTheme ? `#${NavbarBtnColorTheme}` : '#171717'">
                        mdi-filter-variant
                      </v-icon>
                      <v-tooltip activator="parent" location="top" width="200">
                        {{ $t('_filterConversations') }}
                      </v-tooltip>
                    </v-btn>
                  </template>
                  <v-card class="optioncard">
                    <v-card-text>
                      <v-list density="compact" class="pa-0">
                        <v-list-item
                          v-for="option in options"
                          :key="option"
                          @click="contactStatus = option.value"
                          v-model="contactStatus"
                          color="#C32E0E"
                          class="pa-0"
                        >
                          <v-list-item-title
                            :class="contactStatus == option.value ? 'text-red-darken-3' : ''"
                          >
                            {{ option.text }}
                          </v-list-item-title>

                          <template #append>
                            <v-icon v-if="contactStatus == option.value" color="#C32E0E" icon="mdi-check" />
                          </template>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                    <v-card-actions style="border-top: 1px solid #CCCCCC80;">
                      <v-btn class="savebtn" @click="Search()">
                        {{ $t('apply') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
            </v-card-title>
            <v-card-text class="fill-height pa-0" ref="TopicContainer">
              <!-- User List Content -->
              <v-skeleton-loader :loading="loadingTopic" type="list-item-two-line" :height="sizeTopic + 'dvh'">
                <!-- Empty state message when no topics are available -->
                <v-list v-if="!(topic.length > 0)" density="compact">
                  <v-list-item>
                    {{ $t('noDataAvailable') }}
                  </v-list-item>
                </v-list>

                <!-- Topic list with virtual scroll for performance -->
                <v-list v-else density="compact" class="pa-0 mt-0 chatservice-topic-list-container"
                  style="height: 100%;width: 100%;">
                  <v-list-item-group v-model="selectedItem" mandatory :color="selectedColor"
                    class="chatservice-topic-list-group">
                    <v-virtual-scroll ref="scrollerMenuModel" :style="{
                      height: `${sizeTopic}dvh`,
                      borderRadius: '12px',
                      overflow: 'auto',
                      maxHeight: `${sizeTopic}dvh`
                    }" :items="topic" :item-height="67" bench="20" @scroll="TopicScroll"
                      class="chatservice-topic-virtual-scroll chatservice-scrollable">
                      <template v-slot:default="{ item, index }">
                        <div :key="`topic${index}`" :value="item.topicId" class="chatservice-topic-item-wrapper">
                          <v-list-item :disabled="flagGetTopic"
                            @click="flagGetTopic ? '' : handleClick(item.topicID, index, item.socialType)"
                            class="chatservice-topic-list-item">
                            <template #prepend>
                              <v-badge v-if="item.unread" color="red" :content="unreadUserBadge(item)" bordered overlap
                                class="chatservice-topic-badge">
                                <v-avatar size="40" class="chatservice-topic-avatar" :color="getAvatarColor(item.socialType)">
                                  <v-img :src="getListAvatar(item.socialType)" />
                                </v-avatar>
                              </v-badge>
                              <v-avatar v-if="!item.unread" size="40" class="chatservice-topic-avatar" :color="getAvatarColor(item.socialType)">
                                <v-img :src="getListAvatar(item.socialType)" />
                              </v-avatar>
                            </template>

                            <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                            <v-list-item-subtitle class="chatservice-topic-subtitle">
                              {{ item.latestMsg }}
                            </v-list-item-subtitle>

                            <template #append>
                              <div class="chatservice-switch-wrapper">
                                <v-switch @click.stop="handleSwitchChange(item.topicID, item.adminReply)"
                                  v-model="item.adminReply" density="compact" hide-details inset color="primary"
                                  class="chatservice-topic-switch chatservice-switch-label-left" :ripple="false"
                                  :label="item.adminReply ? ('admin') : ('bot')">
                                  <template #label>
                                    <span :class="[
                                      'chatservice-switch-label',
                                      item.adminReply ? 'is-admin' : 'is-bot'
                                    ]">
                                    <v-img
                                          width="25"
                                          height="22"
                                          class="mr-1"
                                          :src="item.adminReply ? images.admin : images.bot"
                                          :class="[
                                            item.adminReply ? 'is-adminimg' : 'is-botimg'
                                          ]"
                                          alt="role icon"
                                        />
                                      {{ item.adminReply ? ('admin') : ('bot') }}
                                    </span>
                                  </template>
                                </v-switch>
                              </div>
                            </template>
                          </v-list-item>
                          <v-divider :key="`chatDivider${index}`" class="chatservice-topic-divider" />
                        </div>
                      </template>
                    </v-virtual-scroll>
                  </v-list-item-group>
                </v-list>
              </v-skeleton-loader>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <!-- Chat Section -->
      <v-slide-x-transition>
        <v-col cols="12" v-show="!showUserList && !reponseWidth" class="flex-grow-1 flex-shrink-0 pt-0">
          <v-responsive class="overflow-y-hidden fill-height view-height">
            <!-- Main chat container with improved responsive layout -->
            <v-card class="d-flex flex-column fill-height"
              style="border: 1px solid #e0e0e0; border-radius: 15px; height: 100%;width: 100%;box-shadow: none;">
              <v-card-title style="display: flex;">
                {{ $t('chat') }}
                <v-spacer />

                <!-- Filter menu with updated responsive positioning -->
                <v-menu location="bottom start" min-width="300" :close-on-content-click="false"
                  v-model="menuOpen" transition="scale-transition">
                  <template v-slot:activator="{ props }">
                    <v-btn icon variant="text" v-bind="props">
                      <v-icon style="cursor: pointer;"
                        :color="NavbarBtnColorTheme ? `#${NavbarBtnColorTheme}` : '#5179ef'">
                        mdi-filter-variant
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="subtitle-1" style="padding-bottom: 0px !important;">
                      {{ $t('filterOptions') }}
                    </v-card-title>

                    <v-card-text>
                      <v-radio-group v-model="contactStatus">
                        <v-subheader class="pl-0">{{ $t('contactStatus') }}</v-subheader>
                        <v-radio :label="$t('all')" value="all"></v-radio>
                        <v-radio :label="$t('contactAgent')" value="agent"></v-radio>
                        <v-radio :label="$t('contactBot')" value="bot"></v-radio>
                      </v-radio-group>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn variant="text" color="red" @click="resetFilter">
                        {{ $t('_Reset') }}
                      </v-btn>
                      <v-btn color="primary" @click="Search()">
                        {{ $t('apply') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>

                <!-- Toggle user list button with responsive styling -->
                <v-app-bar-nav-icon style="cursor: pointer;" :style="{
                  color: `#${NavbarBtnColorTheme || '5179ef'}`
                }" @click="toggleUserList" :aria-label="$t('_toggleUserList')"></v-app-bar-nav-icon>
              </v-card-title>

              <!-- Chat list with enhanced responsive skeleton loader -->
              <v-card-text class="fill-height pa-0" ref="TopicContainer">
                <v-skeleton-loader :loading="loadingTopic" type="list-item-two-line" :height="sizeTopic + 'dvh'">
                  <!-- Empty state message when no topics are available -->
                  <v-list v-if="!(topic.length > 0)" density="compact">
                    <v-list-item>
                      {{ $t('noDataAvailable') }}
                    </v-list-item>
                  </v-list>

                  <!-- Topic list with virtual scroll for performance -->
                  <v-list v-else density="compact" class="pa-0 mt-0 chatservice-topic-list-container"
                    style="height: 100%;width: 100%;">
                    <v-list-item-group v-model="selectedItem" mandatory :color="selectedColor"
                      class="chatservice-topic-list-group">
                      <v-virtual-scroll ref="scrollerMenuModel" :style="{
                        height: `${sizeTopic}dvh`,
                        borderRadius: '12px',
                        overflow: 'auto',
                        maxHeight: `${sizeTopic}dvh`
                      }" :items="topic" :item-height="67" bench="20" @scroll="TopicScroll"
                        class="chatservice-topic-virtual-scroll chatservice-scrollable">
                        <template v-slot:default="{ item, index }">
                          <div :key="`topic${index}`" :value="item.topicId" class="chatservice-topic-item-wrapper">
                            <v-list-item :disabled="flagGetTopic"
                              @click="flagGetTopic ? '' : handleClick(item.topicID, index, item.socialType)"
                              class="chatservice-topic-list-item">
                              <template #prepend>
                                <v-badge v-if="item.unread" color="red" :content="unreadUserBadge(item)" bordered overlap
                                  class="chatservice-topic-badge">
                                  <v-avatar size="40" class="chatservice-topic-avatar" :color="getAvatarColor(item.socialType)">
                                    <v-img :src="getListAvatar(item.socialType)" />
                                  </v-avatar>
                                </v-badge>
                                <v-avatar v-if="!item.unread" size="40" class="chatservice-topic-avatar" :color="getAvatarColor(item.socialType)">
                                  <v-img :src="getListAvatar(item.socialType)" />
                                </v-avatar>
                              </template>

                              <v-list-item-title class="chatservice-topic-title" v-text="item.displayName" />
                              <v-list-item-subtitle class="chatservice-topic-subtitle">
                                {{ item.latestMsg }}
                              </v-list-item-subtitle>

                              <template #append>
                                <div class="chatservice-switch-wrapper">
                                  <v-switch @click.stop="handleSwitchChange(item.topicID, item.adminReply)"
                                    v-model="item.adminReply" density="compact" hide-details inset color="primary"
                                    class="chatservice-topic-switch chatservice-switch-label-left" :ripple="false"
                                    :label="item.adminReply ? ('admin') : ('bot')">
                                    <template #label>
                                      <v-img
                                          width="25"
                                          height="22"
                                          class="mr-1"
                                          :src="item.adminReply ? images.admin : images.bot"
                                          alt="role icon"
                                          :class="[
                                            item.adminReply ? 'is-adminimg' : 'is-botimg'
                                          ]" />
                                      <span :class="[
                                        'chatservice-switch-label',
                                        item.adminReply ? 'is-admin' : 'is-bot'
                                      ]">
                                        {{ item.adminReply ? ('admin') : ('bot') }}
                                      </span>
                                    </template>
                                  </v-switch>
                                </div>
                              </template>
                            </v-list-item>
                            <v-divider :key="`chatDivider${index}`" class="chatservice-topic-divider" />
                          </div>
                        </template>
                      </v-virtual-scroll>
                    </v-list-item-group>
                  </v-list>
                </v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-responsive>
        </v-col>
      </v-slide-x-transition>
      <v-col :cols="conversationCols" v-show="!reponseWidth ? showUserList : true"
        class="flex-grow-1 flex-shrink-0 pt-0">
        <v-responsive class="overflow-y-hidden fill-height view-height">
          <!-- h-fill-available -->
          <v-card class="d-flex flex-column fill-height"
            style="border:  1px solid #e0e0e0; border-radius: 12px;box-shadow: none;">
            <v-skeleton-loader :loading="loadingUsername" type="card-heading">
              <v-card-title class="d-flex align-center justify-space-between"
                style="width: 100%;border-bottom: 1px solid #e0e0e0;">
                {{ user ? user : $t('_userNotSelected') }}
                <v-btn v-if="!showProfileColumn && !!user" icon variant="text" width="40" class="maxtoggle ml-auto" :aria-label="$t('_customerProfile')" data-testid="profile-toggle-btn" @click="profileDrawer = true">
                  <v-icon :color="NavbarBtnColorTheme ? `#${NavbarBtnColorTheme}` : '#171717'">mdi-account-box-outline</v-icon>
                  <v-tooltip activator="parent" location="top">{{ $t('_customerProfile') }}</v-tooltip>
                </v-btn>
                <v-btn variant="text" width="40"  @click="toggleUserList" class="maxtoggle">
                  <v-img v-if="showUserList" :src="images.maxImg" alt="Maximize" width="24" height="24"></v-img>
                  <v-img v-else :src="images.minImg" alt="Minimize" width="24" height="24"></v-img>
                  <v-tooltip activator="parent" location="top">
                      {{ showUserList ? $t('expand') : $t('minimize') }}
                  </v-tooltip>
                </v-btn>
              </v-card-title>
            </v-skeleton-loader>
            <v-row class="ma-0 ">
              <v-col cols="12" v-if="loadingMessage" class="py-0" style="height: 100vh;position: sticky;">
                <v-progress-linear indeterminate :color="selectedColor" class="mb-0"></v-progress-linear>
              </v-col>
            </v-row>
            <v-skeleton-loader class="flex-grow-1 pa-4" v-if="StartupLoadingMessage"
              type="list-item-three-line,list-item-two-line">
            </v-skeleton-loader>
            <v-card-text class="flex-grow-1 overflow-y-auto pt-2" ref="scrollContainer" @scroll="ChatScreScroll"
              v-if="user">
              <!-- Chat Messages -->
              <div v-for="(msg, index) in messages" :id="'ChatId_' + msg.id" :key="index">
                <!-- System/Switch message when switchShow is true -->
                <div v-if="msg.switchShow == true"  class="system-message-container">
                  <div class="system-message-wrapper">
                    <div class="system-message-content">
                      <div class="divider"></div>
                      <span class="system-message-text">{{ msg.messageBot || $t('_chatSwitchedToAdmin') }}</span>
                      <div class="divider"></div>
                    </div>
                  </div>
                </div>
                <div v-if="msg.messageUser != null" class="chat-box d-flex align-center"
                  style="display: flex !important;align-items: flex-start;">
                  <div class="message pa-2 mb-3" style="line-break: anywhere;
                        padding: 0px 4px;
                        border-radius: 15px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 22px;
                        display: flex;
                        width: fit-content;
                        float: right;
                        background-color: #E0E0E0;
                        min-height: 35px;max-width: 80%;  margin-top:2px;  margin-right: 6px;">
                    <MarkdownRenderer :content="msg.messageUser" />
                  </div>
                  <sub class="ml-1 mb-3" style="font-size: 10px;">{{ msg.requestTime }}</sub>
                </div>
                <div v-if="msg.messageBot != null && msg.switchShow == false" class="chat-box d-flex align-center"
                  style="justify-content: flex-end; align-items: flex-end;">
                  <sub class="mr-2 mb-3" style="font-size: 10px;">{{ msg.responseTime }}</sub>
                  <div class="message pa-2 mb-3 white--text" :color="selectedColor + 'DD'" 
                  :class="{ 'message-media': hasMediaContent(msg.messageBot), 'message-text': !hasMediaContent(msg.messageBot) }"
                  :style="[{ backgroundColor: selectedColor + 'DD' }, { border: '1px solid' + selectedColor }, chatServiceMessageTextStyle]"  >
                     <!-- testing -->
                    <MarkdownRenderer :content="msg.messageBot" />
                  </div>
                  <v-avatar v-if="!hasMediaContent(msg.messageBot)" size="25">
                    <v-img v-if="msg.contactAgentMode"
                      :src="images.admin" 
                      alt='Admin'
                    />
                    <v-icon v-if="!isImgIconChat && !msg.contactAgentMode"
                      :style="'color:' + selectedColor + ';'">{{ ChatbotIcon != null
                        ?
                        ChatbotIcon : 'mdi-robot-outline' }}</v-icon>
                    <v-img v-if="isImgIconChat && !msg.contactAgentMode" style="border-radius: 50%;"
                      :src="IconChat" />
                  </v-avatar>
                </div>
              </div>
            </v-card-text>
            <v-card-text class="flex-shrink-1 chatcard" style="position:relative;" v-if="topic.length > 0 && user">
              <div class="chatservice-input-container">
                <!-- File preview section -->
                <div v-if="previews.length > 0" class="chatservice-file-preview-section">
                  <div class="chatservice-file-preview-grid">
                    <div v-for="(file, index) in previews" :key="index" class="chatservice-file-preview-item">
                      <div class="chatservice-file-preview-card">
                        <v-img :src="file.src" class="chatservice-file-preview-image" height="100" width="100" cover />
                        <div class="chatservice-file-preview-overlay">
                          <v-btn size="small" icon="mdi-close" variant="elevated"
                            @click="removeFile(index)" class="chatservice-file-remove-btn" />
                        </div>
                        <v-tooltip :text="file.filename" location="top">
                          <template v-slot:activator="{ props }">
                            <div v-bind="props" class="chatservice-file-name">
                              {{ file.filename }}
                            </div>
                          </template>
                        </v-tooltip>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- Main input area -->
                <div class="chatservice-input-wrapper" :class="{'chatservice-input-wrapper--has-files': previews.length > 0}">
                  <!-- File upload button -->
                  <v-btn v-if="previews.length == 0" variant="text" icon="mdi-paperclip" size="large" :disabled="!user" :loading="isSelecting"
                    @click="onButtonClick($event), filesMore = false"
                    class="chatservice-input-action-btn chatservice-attachment-btn">
                    <v-img :src="images.paperclip" width="28" height="28" alt="paper-clip"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t('attachFiles') }}
                    </v-tooltip>
                  </v-btn>
                  <!-- Add more files button -->
                    <div v-if="previews.length > 0">
                      <v-btn variant="text" color="#C32E0E" class="chatservice-send-btn"
                       @click="onButtonClick($event), filesMore = true">
                       <v-icon>mdi-plus</v-icon>
                       <v-tooltip activator="parent" location="bottom">
                        {{ $t('addMore') }}
                      </v-tooltip>
                       </v-btn>
                    </div>
                  <div style="border: 1px solid #949AA880; height: 28px;"></div>
                  <!-- Hidden file input -->
                  <input ref="uploader" type="file" accept="image/*,audio/mp3,video/mp4,audio/x-m4a,application/*"
                    @change="onFileChanged" id="upload-file" :aria-label="$t('uploadFile')" multiple style="display: none;" />

                  <!-- Text input -->
                  <div class="chatservice-text-input-container">
                    <v-textarea ref="RefMessageData" v-model="messageForm.text" :placeholder="$t('_typeYourMessage')"
                      variant="outlined" rows="1" :disabled="!user"
                      @input="queueTextareaResize"
                      @keydown.enter.ctrl.prevent="''"
                      @keydown.enter.exact.prevent="(messageForm.text.length > 0 || previews.length > 0) && !statusSendMessage ? sendMessage($event) : ''"
                      hide-details class="chatservice-chat-input" density="comfortable" />
                  </div>

                  <!-- Action buttons -->
                  <div class="chatservice-input-actions">
                    <!-- Send button -->
                    <v-btn v-if="!statusSendMessage" :disabled="messageForm.text.trim() === '' && previews.length === 0"
                      @click.stop="sendMessage($event)" variant="text"
                      class="chatservice-send-btn">
                      <v-img v-if="messageForm.text.length > 0 || previews.length > 0" :src="images.sendIcon" width="30" height="30" variant="flat" alt="send-icon"></v-img>
                      <v-img v-else :src="images.disabledSendIcon" width="30" height="30" variant="flat" alt="send-icon"></v-img>
                    </v-btn>
                    <!-- Loading button -->
                    <v-btn v-else icon="mdi-loading mdi-spin" color="primary" variant="flat" size="large" disabled
                      class="chatservice-send-btn chatservice-loading" />
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-text class="flex-grow-1 pt-2" v-else style="height: 100vh; display: flex; justify-content: center; align-items: center;">
              {{ $t('noDataAvailable') }}
            </v-card-text>
          </v-card>
        </v-responsive>
      </v-col>
      <v-col v-if="showProfileColumn" cols="3" class="flex-grow-1 flex-shrink-0 pt-0">
        <div class="overflow-y-hidden fill-height view-height">
          <CustomerProfilePanel v-bind="profilePanelProps" @transfer="onTransferClick" @close="onCloseChatClick" @retry="LoadCustomerProfile(currentTopicId)" />
        </div>
      </v-col>
    </v-row>
    <v-navigation-drawer v-if="profileAsDrawer" v-model="profileDrawer" location="right" temporary width="360" data-testid="profile-drawer" tabindex="-1" @keydown.esc="profileDrawer = false">
      <CustomerProfilePanel v-bind="profilePanelProps" dismissible @transfer="onTransferClick" @close="onCloseChatClick" @retry="LoadCustomerProfile(currentTopicId)" @dismiss="profileDrawer = false" />
    </v-navigation-drawer>
    <v-bottom-sheet v-else-if="profileAsSheet" v-model="profileDrawer">
      <div class="chatservice-profile-sheet" data-testid="profile-sheet" v-touch="{ start: (e) => { profileSheetAtTop = !e.originalEvent.currentTarget.querySelector('.chatservice-profile-body')?.scrollTop; }, down: () => { if (profileSheetAtTop) profileDrawer = false; } }">
        <CustomerProfilePanel v-bind="profilePanelProps" dismissible @transfer="onTransferClick" @close="onCloseChatClick" @retry="LoadCustomerProfile(currentTopicId)" @dismiss="profileDrawer = false" />
      </div>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import signalRService from "@/services/signalr-service";
import Cookies from "js-cookie";
import { useDisplay } from 'vuetify'
// import VueMarkdown from 'vue-markdown-v2'
import MarkdownRenderer from '@/components/MarkedMarkdown.vue'
import ChannelTabs from '@/components/ChatService/ChannelTabs.vue';
import CustomerProfilePanel from '@/components/ChatService/CustomerProfilePanel.vue';
import facebookImg from "@/assets/brand/Facebooklogo.png";
import instagramImg from "@/assets/brand/Instagramlogo.png";
import lineImg from "@/assets/brand/Linelogo.png";
import allTab from '@/assets/brand/Alltab.png';
import facebookTab from '@/assets/brand/Facebooktab.png';
import instagramTab from '@/assets/brand/Instagramtab.png';
import lineTab from '@/assets/brand/Linetab.png';
import tiktokImg from '@/assets/brand/TikToklogo.png';
import tiktokTab from '@/assets/brand/TikToktab.png';
import shopeeImg from '@/assets/brand/Shopeelogo.png';
import shopeeTab from '@/assets/brand/Shopeetab.png';
import lazadaImg from '@/assets/brand/Lazadalogo.png';
import lazadaTab from '@/assets/brand/Lazadatab.png';
import fileLinkIcon from '@/assets/images/file-link-svgrepo-com.svg';
import fileAudioIcon from '@/assets/images/file-audio-svgrepo-com.svg';
import fileVideoIcon from '@/assets/images/file-video-svgrepo-com.svg';
import admin from '@/assets/images/admin.png';
import bot from '@/assets/images/bot.png';
import maxImg from '@/assets/Icons/maximize.png';
import minImg from '@/assets/Icons/mini.svg';
import paperclip from '@/assets/Icons/Attachment.png';
import sendIcon from '@/assets/Icons/sendicon.png';
import disabledSendIcon from '@/assets/Icons/disablesendicon.png';
import botavatar from '@/assets/Icons/botavatar.svg';

export default {
  components: {
    MarkdownRenderer, ChannelTabs, CustomerProfilePanel
  },
  inject: [
    'flagNav', 'tabSocialType', 'NavbarBtnColorTheme', 'colorThemeChat'
    , 'IconChat', 'isImgIconChat', 'ChatbotIcon', 'ChatPanelFontColorTheme', 'loadChannelTabs'
  ],
  setup() {
    // ใช้ useDisplay เพื่อเข้าถึง breakpoint
    const display = useDisplay()
    return { display }
  },
  data() {
    return {
      anchorAttrs: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      },
      urlApi: import.meta.env.VITE_APP_API,
      date: new Date().toISOString().substr(0, 10),
      today: null,
      showUserList: true,
      user: "",
      currentTopicId: 0,
      Log_History_ID: 0,
      Log_History_Take: 5,
      roleId: 0,
      logoBrand: {
        facebook: facebookImg,
        instagram: instagramImg,
        line: lineImg,
        allTab: allTab,
        facebookTab: facebookTab,
        instagramTab: instagramTab,
        lineTab: lineTab,
        tiktok: tiktokImg,
        shopee: shopeeImg,
        lazada: lazadaImg,
        tiktokTab: tiktokTab,
        shopeeTab: shopeeTab,
        lazadaTab: lazadaTab,
      },
      currentIndex: 0,
      images:{
        admin: admin,
        bot: bot,
        maxImg: maxImg,
        minImg: minImg,
        paperclip: paperclip,
        sendIcon: sendIcon,
        disabledSendIcon: disabledSendIcon,
        botavatar: botavatar,
      },
      chatSelected: { topicId: 30, name: "21905fbb-c055-41e2-8ec0-6bb9d2c29ecc", platform: "facebook" },
      selectedItem: 0,
      messages: [],
      messageForm: {
        text: "",
        me: true,
        created_at: new Date().toISOString().substr(0, 10),
      },
      messageTextareaMaxRows: 3,
      topic: [],
      history: {
        userMsg: [],
        replyMsg: [],
        createDate: []
      },
      scrollMessagesCount: 0,
      notifications: null,
      selectedColor: '#FFA41E',
      isSelecting: false,
      previews: [],
      loadingMessage: false,
      flagTopHistory: false,
      flagloadingTopic: false,
      StartupLoadingMessage: false,
      loadingUsername: false,
      Key_Ctrl_Flag: false,
      statusSendMessage: false,
      flagGetTopic: false,
      Axios_ControllerTopic: null,
      loadingTopic: false,
      loadingHistory: false,
      search: "",
      SocialType: "",
      menuOpenFull: false,
      menuOpen: false,
      contactStatus: "all",
      filterAgent: ["All", "Contact Agent", "No Contact"],
      textareaResizeFrame: null,
      totalchats: 0,
      bulkClearLoading: false,
      suppressTopicUnreadRefresh: false,
      profile: null,
      profileLoading: false,
      profileError: null,
      profileAbort: null,
      profileDrawer: false,
      profileSheetAtTop: true,
      transferBusy: false,
      closeBusy: false,
      closingTopicId: null,
      readRequestsInFlight: new Set(),
    };
  },
  watch: {
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;
    },
    "display.width.value": function () {
      this.setResponsive();
    },
    "display.height.value": function () {
      this.setResponsive();
    },
    "messageForm.text": function () {
      this.queueTextareaResize();
    },
    'tabSocialType.length'(len) {
      if (this.currentIndex >= len) {
        this.currentIndex = 0;
        this.onTabChange(0);
      }
    },
    showProfileColumn(v) {
      if (v) this.profileDrawer = false;
    },
    profileDrawer(v) {
      this.$nextTick(() => document.querySelector(v ? '[data-testid="profile-drawer"]' : '[data-testid="profile-toggle-btn"]')?.focus());
    },
  },
  computed: {
    options() {
      return [
        { text: this.$t('allChats'), value: 'all' },
        { text: this.$t('agentOnly'), value: 'agent' },
        { text: this.$t('botOnly'), value: 'bot' },
      ];
    },
    sizeTopic() {
      switch (this.display.name.value) {
        case 'xs': return 64
        case 'sm': return 64
        case 'md': return 68
        case 'lg': return 64
        case 'xl': return 72
        case 'xxl': return 80
        default: return 50
      }
    },
    reponseWidth() {
      return this.display.width.value >= 1024
    },
    reponseHeigth() {
      return this.display.height.value >= 960
    },
    currentItem() {
      if (!this.tabSocialType || !this.tabSocialType.length) return null;
      return this.tabSocialType[this.currentIndex];
    },
    activeTopicLabel() {
      return this.currentItem?.text || this.currentItem?.value || this.$t('allChats');
    },
    chatServiceMessageTextStyle() {
      return {
        color: this.ChatPanelFontColorTheme ? `#${this.ChatPanelFontColorTheme}` : '#FFFFFF',
      };
    },
    showProfileColumn() {
      return this.display.width.value >= 1280;
    },
    profileAsDrawer() {
      return !this.showProfileColumn && this.display.width.value >= 768;
    },
    profileAsSheet() {
      return this.display.width.value < 768;
    },
    denseTabs() {
      return this.display.width.value < 1024;
    },
    listCols() {
      return 3;
    },
    conversationCols() {
      if (!this.reponseWidth) return 12;
      const cols = this.showUserList ? 9 : 12;
      return this.showProfileColumn ? cols - 3 : cols;
    },
    currentTopic() {
      return this.topic.find((t) => t.topicID === this.currentTopicId) || null;
    },
    currentTopicClosed() {
      return this.profile?.interactionHistory?.find((h) => h.isCurrent)?.activeFlag === false;
    },
    profilePanelProps() {
      return {
        topicId: this.topic.length ? this.currentTopicId : 0,
        profile: this.profile,
        loading: this.profileLoading,
        error: this.profileError,
        adminReply: !!this.currentTopic?.adminReply,
        transferBusy: this.transferBusy,
        closeBusy: this.closeBusy,
        sendBusy: this.statusSendMessage,
        closed: this.currentTopicClosed,
        themeColor: this.selectedColor,
        getLogo: this.getSocialLogo,
        getColor: this.getSocialColor,
      };
    },
  },
  beforeDestroy() {
    if (this.textareaResizeFrame && typeof cancelAnimationFrame === 'function') {
      cancelAnimationFrame(this.textareaResizeFrame);
      this.textareaResizeFrame = null;
    }
    this.profileAbort?.abort();
    // Unregister ChatService's event handlers (don't disconnect - other components may use it)
    signalRService.offAll("ChatService");
    console.log("SignalR handlers unregistered for ChatService");
  },
  beforeMount() {
    // Use centralized SignalR service
    this.connectSignalR()
      .then(() => {
      })
      .catch(err => console.log(err));
    
    // Register event handlers
    signalRService.on("ReceivedMessage", "ChatService", (message, topicId) => {
      console.log("ReceivedMessage:", message, topicId);
      if (this.currentTopicId === topicId) {
        let res = {
          "requestTime": this.formatResponseTime(),
          "responseTime": this.formatResponseTime(),
          "id": this.messages.slice(-1)[0].id + 1,
          "messageUser": message,
          "messageImage": null,
          "isRead": null
        }
        this.messages.push(res)
        this.scrollToBottom()
      }
    });

    signalRService.on("BotReply", "ChatService", (message, topicId) => {
      if (this.currentTopicId === topicId) {
        let res = {
          "requestTime": this.formatResponseTime(),
          "responseTime": this.formatResponseTime(),
          "id": this.messages.slice(-1)[0].id + 1,
          "messageBot": message,
          "messageImage": null,
          "isRead": null,
          // the bot bubble only renders when switchShow == false (see template);
          // leaving it undefined made live bot replies invisible until a reload
          "switchShow": false,
          "contactAgentMode": false,
        }
        this.messages.push(res)
        this.scrollToBottom()
      }
    });
    
    signalRService.on("LatestMessageUpdate", "ChatService", (topicId) => {
      let id = { ID: topicId }
      this.$call.LatestMessage(id,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            // Check if topic already exists in the list
            const existingTopicIndex = this.topic.findIndex(t => t.topicID === dataResponse.data.topicID);
            
            if (existingTopicIndex !== -1) {
              // Update existing topic
              this.topic = this.topic.map(currentTopic =>
                currentTopic.topicID === dataResponse.data.topicID ?
                  {
                    ...currentTopic,
                    latestMsg: dataResponse.data.latestMsg,
                    updateDate: dataResponse.data.updateDate,
                    adminReply: dataResponse.data.adminReply,
                    unread: this.currentTopicId == topicId ? false : dataResponse.data.unread,
                  }
                  : currentTopic
              );
            }
            // Only add new topic if it's in contact agent mode (adminReply === true)
            // Topics where user hasn't requested agent contact should not appear in the list
            else if (dataResponse.data.adminReply === true) {
              // Add new topic to the list - map field names from Topic_Log_Message to SocialChat format
              const newTopic = {
                topicID: dataResponse.data.topicID,
                displayName: dataResponse.data.topicName || dataResponse.data.displayName || dataResponse.data.socialType + ' User',
                latestMsg: dataResponse.data.latestMsg,
                updateDate: dataResponse.data.updateDate,
                socialType: dataResponse.data.socialType,
                adminReply: dataResponse.data.adminReply,
                unread: this.currentTopicId == topicId ? false : dataResponse.data.unread,
                totalCount: this.totalchats + 1
              };
              this.topic.push(newTopic);
              // Update total count
              this.totalchats = this.totalchats + 1;
            }
            
            this.topic = this.topic.sort((a, b) => new Date(b.updateDate) - new Date(a.updateDate));
            this.selectedItem = this.topic.findIndex(e => e.topicID == this.currentTopicId)
            if (this.currentTopicId == topicId && dataResponse.data.unread === true) {
              this.MarkAsRead(topicId);
            } else {
              this.TopicUnread();
            }
          }
        },
        (errorResource) => {
          console.error("Error: ", errorResource)
        })
    });

    signalRService.on("AdminStatus", "ChatService", (topicID, status = true) => {
      this.$call.AdminReplyStatus(
        topicID, status, (dataResponse) => {
          if (dataResponse.status === 0) {
            let tempTopic = this.topic.find(topic => topic.topicID === topicID);
            if (tempTopic) {
              tempTopic.adminReply = status;
            }
          }
          else {
            this.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
          }
        }, (errorResource) => {
          console.error(errorResource);
        }
      )
    });

    // Register lifecycle event handlers
    signalRService.on("_reconnecting", "ChatService", () => {
      console.warn("Reconnecting...");
    });

    signalRService.on("_reconnected", "ChatService", async () => {
      try {
        await this.UserSelect(this.currentTopicId, "")
        this.TopicUnread();
        this.loadChannelTabs?.();
        console.log("Reconnection Success.")
      }
      catch (error) {
        console.log(error)
      }
    });

    signalRService.on("TopicUnread", "ChatService", () => {
      if (this.suppressTopicUnreadRefresh) {
        return;
      }
      this.TopicUnread();
    });

    signalRService.on('TopicClosed', 'ChatService', (topicId) => {
      this.removeClosedTopic(Number(topicId), Number(topicId) !== this.closingTopicId);
    });

    signalRService.on('SendFailed', 'ChatService', (topicId, errorCode, origin) => {
      if (Number(topicId) !== this.currentTopicId) return;
      this.toast('warning', origin === 'admin' ? this.$t('_sendFailedAdmin') : this.$t('_sendFailedBot'), 5000, this.sendFailedReason(errorCode));
    });
  },
  mounted() {
    this.GetDate();
    this.Themecolor();
    this.loadChannelTabs?.();
    this.TopicUnread();
    this.GetTopicAll("mounted");
    this.setResponsive();
    this.queueTextareaResize();
  },
  methods: {
    // connect() ignores the request when roleId is null, so always pass the role
    // and the current path just like NavBar does
    connectSignalR() {
      return signalRService.connect(Cookies.get("roleId"), this.$route?.path ?? "");
    },
    queueTextareaResize() {
      if (typeof requestAnimationFrame === 'undefined') {
        this.$nextTick(() => this.adjustChatTextareaHeight());
        return;
      }
      if (this.textareaResizeFrame && typeof cancelAnimationFrame === 'function') {
        cancelAnimationFrame(this.textareaResizeFrame);
      }
      this.textareaResizeFrame = requestAnimationFrame(() => {
        this.adjustChatTextareaHeight();
        this.textareaResizeFrame = null;
      });
    },
    adjustChatTextareaHeight() {
      if (globalThis.window === undefined) {
        return;
      }
      const ref = this.$refs.RefMessageData;
      const fallbackTextarea = ref && ref.$el && ref.$el.querySelector ? ref.$el.querySelector('textarea') : null;
      const textarea = ref && ref.$refs && ref.$refs.input
        ? ref.$refs.input
        : fallbackTextarea;
      if (!textarea) {
        return;
      }
      textarea.style.height = 'auto';
      const computed = globalThis.getComputedStyle(textarea);
      const lineHeight = Number.parseFloat(computed.lineHeight) || 20;
      const paddingTop = Number.parseFloat(computed.paddingTop) || 0;
      const paddingBottom = Number.parseFloat(computed.paddingBottom) || 0;
      const padding = paddingTop + paddingBottom;
      const baseHeight = lineHeight + padding;
      const maxHeight = (lineHeight * this.messageTextareaMaxRows) + padding;
      const scrollHeight = textarea.scrollHeight;
      const newHeight = Math.min(Math.max(scrollHeight, baseHeight), maxHeight);
      textarea.style.height = `${newHeight}px`;
      textarea.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
    },
    resetFilter() {
      this.search = "";
      this.contactStatus = "all";
    },
    Search() {
      this.GetTopicAll("search");
      this.menuOpenFull = false;
      this.menuOpen = false;
    },
    unreadUserBadge(item) {
      return item?.unread ? 1 : 0;
    },
    adjustLocalUnreadCount(topic, delta) {
      if (!topic?.socialType || !Array.isArray(this.tabSocialType)) {
        return;
      }

      const updatedTabs = this.tabSocialType.map((item) => {
        if (item.value !== 'All' && item.value !== topic.socialType) {
          return item;
        }

        return {
          ...item,
          unreadCount: Math.max(0, (item.unreadCount || 0) + delta),
        };
      });

      this.tabSocialType.splice(0, this.tabSocialType.length, ...updatedTabs);
    },
    updateSocialUnreadCounts(countUnreads) {
      const unreadCounts = Array.isArray(countUnreads) ? countUnreads : [];

      const updatedTabs = this.tabSocialType.map(item => {
        if (item.value === 'All') {
          const total = unreadCounts.reduce((sum, current) => sum + (current.unreadCount || 0), 0);
          return { ...item, unreadCount: total };
        }

        const match = unreadCounts.find(current => current.socialType === item.value);
        return { ...item, unreadCount: match ? match.unreadCount : 0 };
      });

      // Mutate the provided shared array so Navbar immediately reflects the
      // topic read operation without waiting for a browser refresh or a second
      // SignalR round trip.
      this.tabSocialType.splice(0, this.tabSocialType.length, ...updatedTabs);
    },
    TopicUnread() {
      this.$call.TopicUnread(
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.updateSocialUnreadCounts(dataResponse.data);
          }
        },
        (errorResource) => {
          console.error("TopicUnread error: ", errorResource);
        }
      );
    },
    markAllAsReadRequest() {
      return new Promise((resolve, reject) => {
        this.$call.MarkAllAsRead(
          (dataResponse) => {
            if (dataResponse.status === 0) {
              resolve(dataResponse);
              return;
            }

            reject(new Error(dataResponse.message || this.$t('_unableToClearNotifications')));
          },
          (errorResource) => reject(errorResource)
        );
      });
    },
    clearLocalUnreadState() {
      this.topic = this.topic.map(topic => ({ ...topic, unread: false }));
      const clearedTabs = this.tabSocialType.map(item => ({ ...item, unreadCount: 0 }));
      this.tabSocialType.splice(0, this.tabSocialType.length, ...clearedTabs);
    },
    async clearTopicNotifications() {
      if (this.bulkClearLoading) {
        return;
      }

      const allTab = this.tabSocialType.find(item => item.value === 'All');
      const totalUnreadCount = allTab?.unreadCount || 0;
      const hasLocalUnread = this.topic.some(item => item.unread === true);

      if (totalUnreadCount === 0 && !hasLocalUnread) {
        this.$swal.fire({
          icon: 'info',
          title: this.$t('_noUnreadChats'),
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      this.bulkClearLoading = true;
      this.suppressTopicUnreadRefresh = true;

      try {
        await this.markAllAsReadRequest();
        this.clearLocalUnreadState();
        this.TopicUnread();
        this.$swal.fire({
          icon: 'success',
          title: `${this.activeTopicLabel} ` + this.$t('_markedAsReadSuffix'),
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (errorResource) {
        console.error('MarkAllAsRead error: ', errorResource);
        this.TopicUnread();
        this.$swal.fire({
          icon: 'error',
          title: this.$t('_unableToClearNotifications'),
          showConfirmButton: false,
          timer: 2000,
        });
      } finally {
        this.suppressTopicUnreadRefresh = false;
        this.bulkClearLoading = false;
      }
    },
    getSocialLogo(socialType) {
    switch (socialType) {
      case 'Facebook':
        return this.logoBrand.facebookTab;
      case 'Instagram':
        return this.logoBrand.instagramTab;
      case 'Line':
        return this.logoBrand.lineTab;
      case 'TikTok':
        return this.logoBrand.tiktokTab;
      case 'Shopee':
        return this.logoBrand.shopeeTab;
      case 'Lazada':
        return this.logoBrand.lazadaTab;
      default:
        return null;
    }
  },
  getLogo(platform) {
      switch (platform.toLowerCase()) {
        case "facebook":
          return this.logoBrand.facebookTab;
        case "line":
          return this.logoBrand.lineTab;
        case "instagram":
           return this.logoBrand.instagramTab;
        case "tiktok":
          return this.logoBrand.tiktokTab;
        case "shopee":
          return this.logoBrand.shopeeTab;
        case "lazada":
          return this.logoBrand.lazadaTab;
        case "all":
          return this.logoBrand.allTab;
        default:
          return this.logoBrand.allTab;
      }
    },
  getSocialColor(socialType) {
    switch (socialType) {
      case 'Facebook':
        return '#3859D0'; // Facebook blue
      case 'Instagram':
        return '#C32E0E'; // Instagram pink/red
      case 'Line':
        return '#171717'; // Line green
      case 'TikTok':
        return '#010101';
      case 'Shopee':
        return '#EE4D2D';
      case 'Lazada':
        return '#0F146D';
      case 'All':
        return '#C32E0E'; // Your default blue
      default:
        return '#666666'; // Default gray
    }
  },
    getListAvatar(socialType) {
      const key = (socialType || '').toLowerCase();
      return ['facebook', 'instagram', 'line', 'tiktok', 'shopee', 'lazada'].includes(key) ? this.logoBrand[key] : '';
    },
    getAvatarColor(socialType) {
      if (socialType === 'Line') return 'green-accent-3';
      return ['TikTok', 'Shopee', 'Lazada'].includes(socialType) ? this.getSocialColor(socialType) : 'light-blue';
    },
    LoadCustomerProfile(topicId) {
      this.profileAbort?.abort();
      if (!topicId) return;
      const controller = new AbortController();
      this.profileAbort = controller;
      this.profile = null;
      this.profileLoading = true;
      this.profileError = null;
      const finalize = () => {
        if (this.profileAbort === controller) {
          this.profileLoading = false;
          this.profileAbort = null;
        }
      };
      this.$call.GetCustomerProfile(topicId, { signal: controller.signal },
        (dataResponse) => {
          if (topicId !== this.currentTopicId) return;
          if (dataResponse.status === 0) {
            this.profile = dataResponse.data;
          } else {
            this.profileError = dataResponse.message || this.$t('_profileLoadFailed');
          }
          finalize();
        },
        (errorResource) => {
          if (controller.signal.aborted || topicId !== this.currentTopicId) return;
          this.profileError = errorResource?.message || String(errorResource);
          finalize();
        }
      );
    },
    profileActionsLocked() {
      return this.transferBusy || this.closeBusy || this.statusSendMessage || this.currentTopicClosed || !this.currentTopic;
    },
    async onTransferClick() {
      if (this.profileActionsLocked()) return;
      this.transferBusy = true;
      try {
        await this.handleSwitchChange(this.currentTopic.topicID, this.currentTopic.adminReply);
      } finally {
        this.transferBusy = false;
      }
      if (this.showProfileColumn) this.$refs.RefMessageData?.focus();
    },
    async onCloseChatClick() {
      if (this.profileActionsLocked()) return;
      const topicId = this.currentTopic.topicID;
      const result = await this.$swal.fire({
        icon: 'warning',
        title: this.$t('_closeChatConfirmTitle'),
        text: this.$t('_closeChatConfirmText'),
        showCancelButton: true,
        confirmButtonText: this.$t('_closeChat'),
        cancelButtonText: this.$t('cancel'),
        confirmButtonColor: '#c32e0e',
        reverseButtons: true,
      });
      if (!result.isConfirmed) return;
      this.closeBusy = true;
      this.closingTopicId = topicId;
      this.$call.CloseChat({ topicId },
        (dataResponse) => {
          this.closeBusy = false;
          this.closingTopicId = null;
          if (dataResponse.status === 0) this.toast('success', this.$t('_chatClosed'), 2000);
          else this.toast('info', this.$t('_chatAlreadyClosed'), 3000);
          this.removeClosedTopic(topicId);
        },
        (errorResource) => {
          console.error(errorResource);
          this.closeBusy = false;
          this.closingTopicId = null;
          this.toast('error', this.$t('_closeChatFailed'), 4000);
        }
      );
    },
    toast(icon, title, timer, text) {
      this.$swal.fire({ toast: true, position: 'top-end', icon, title, text, timer, showConfirmButton: false });
    },
    // R7 — no-op when the topic is not in this list (TopicClosed is broadcast to every company)
    removeClosedTopic(topicId, fromRemote = false) {
      const wasCurrent = topicId === this.currentTopicId;
      const before = this.topic.length;
      this.topic = this.topic.filter((t) => t.topicID !== topicId);
      if (this.topic.length === before) return;
      this.totalchats = Math.max(0, this.totalchats - 1);
      if (wasCurrent) {
        if (fromRemote) this.toast('info', this.$t('_chatClosedElsewhere'), 4000);
        this.profile = null;
        this.profileDrawer = false;
        if (this.topic.length) {
          this.selectedItem = 0;
          this.UserSelect(this.topic[0].topicID, this.topic[0].socialType);
        } else {
          this.resetTopicState();
          this.currentTopicId = 0;
        }
      }
      this.loadChannelTabs?.();
    },
    sendFailedReason(code) {
      const key = '_sendFailedReason_' + code;
      return this.$te(key) ? this.$t(key) : (code || '');
    },
    onTabChange(newTab) {
      if (!this.tabSocialType[newTab]) return;
      this.currentIndex = newTab;
      this.SocialType = this.tabSocialType[newTab].value;
      this.GetTopicAll("changeTab");
    },
    setResponsive() {
      this.$nextTick(() => { // measure after DOM settles (tabs row is v-if + dense/height swap on resize)
        const tabsRow = this.$el?.querySelector?.('.channel-tabs-card')?.closest('.v-col');
        const isHeight = (this.reponseHeigth ? this.display.height.value - 196 : this.display.height.value - 140) - (tabsRow?.offsetHeight ?? 0);
        document.documentElement.style.setProperty('--responsiveSizeW', this.display.width.value + 'px');
        document.documentElement.style.setProperty('--responsiveSizeH', isHeight + 'px');
      });
    },
    onButtonClick() {
      this.isSelecting = true
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true })

      this.$refs.uploader.click()
    },
    onFileChanged(item) {
      let files = item.target.files;
      if (!files || files.length === 0) {
        return; // หยุดฟังฝ์ชันถ้าไม่มีไฟล์ที่เลือฝ (ฝดยฝเลิฝ)
      }
      if (!this.filesMore) {
        this.previews = [];
      }
      for (const file of files) {
        const reader = new FileReader();

        let fileType = "";
        if (file.type.startsWith("image/")) {
          fileType = "image";
        } else if (file.type.startsWith("audio/")) {
          fileType = "audio";
        } else if (file.type.startsWith("video/")) {
          fileType = "video";
        }
        reader.onload = (e) => {
          switch (fileType) {
            case "image": {
              this.previews.push({ src: e.target.result, file, filename: file.name });
              break;
            }
            case "audio": {
              this.previews.push({ src: fileAudioIcon, file, filename: file.name });
              break;
            }
            case "video": {
              this.previews.push({ src: fileVideoIcon, file, filename: file.name });
              break;
            }
            default: {
      this.previews.push({ src: fileLinkIcon, file, filename: file.name });
              break;
            }
          }

        };
        reader.readAsDataURL(file);
      }
      this.$refs.uploader.value = "";
    },
    removeFile(index) {
      if (this.previews.length == 1) {
        this.previews = [];
        this.$refs.uploader.value = "";
      } else {
        this.previews.splice(index, 1);
      }
    },
      hasMediaContent(messageContent) {
        if (!messageContent) return false;
        
        const imageMarkdownPattern = /!\[.*?\]\(.*?\)/g;
        const mediaExtensions = /\.(jpg|jpeg|png|gif|webp|mp4|avi|mov|wmv|flv|webm|mkv)(\?.*)?$/i;
        const mediaUrlPattern = /(https?:\/\/.*\.(jpg|jpeg|png|gif|webp|mp4|avi|mov|wmv|flv|webm|mkv))/gi;
        if (imageMarkdownPattern.test(messageContent)) {
          return true;
        }
        if (mediaUrlPattern.test(messageContent)) {
          return true;
        }
        if (mediaExtensions.test(messageContent)) {
          return true;
        }
        if (messageContent.includes('data:image/')) {
          return true;
        }
        return false;
      },
    async joinCurrentTopic() {
      if (!signalRService.connected) {
        return;
      }
      try {
        await signalRService.invoke("JoinChat", this.currentTopicId, signalRService.connectionId);
      } catch (err) {
        console.error("JoinChat error:", err);
      }
    },
    async handleClick(topicID, index, socialType) {
      if (!this.flagGetTopic) {
        await this.UserChange(topicID, socialType);
        this.selectedItem = index;
      }
      this.switchClicked = false;
    },
    async handleSwitchChange(topicID, status) {
      this.switchClicked = true;
      await signalRService.invoke("AdminReplyStatus", topicID, !status)
    },

    Themecolor() {
      this.selectedColor = this.colorThemeChat == null ? '#FFA41E' : `#${this.colorThemeChat}`;
    },

    Ctrl_Enter_MessageData() {
      let text = this.messageForm.text;

      let _point = (this.$refs.RefMessageData.$refs.input.selectionStart - 1);
      this.$nextTick(() => {
        this.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        this.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;
        if (this.$refs.RefMessageData.$refs.input &&
          this.$refs.RefMessageData.$refs.input.selectionStart >= text.length
        ) {
          const height = this.$refs.RefMessageData.$refs.input.scrollHeight
          this.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      })
    },
    sendMessage(e) {
      let text = this.messageForm.text;
      const formData = new FormData();
      if (!signalRService.connected) {
        this.connectSignalR().then(() => {
          console.warn("Reconnecting...");
          this.sendMessage(e)
        });
        return;
      }
      if (text.trim() == "" && this.previews.length == 0) {
        return;
      }

      this.statusSendMessage = true;
      this.messageForm.text = "";
      if (this.previews.length > 0) {
        let Axios_Controller = new AbortController();
        let Config = {
          signal: Axios_Controller.signal
        }
        this.previews.forEach((e) => {
          formData.append(`files`, e.file); // Append each file to formData
        });
        let temp = {
          files: formData,
          // req: {
          type: "Line",
          topic: this.currentTopicId,
          // }
        }
        this.$call.SendFileMessage(temp, Config,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let temp = dataResponse.data;
              this.previews = [];
              temp.forEach((e) => {
                let tempObj = {
                  text: e.text,
                  groupID: e.groupID,
                  fileID: e.fileID,
                }
                let tempText = JSON.stringify(tempObj);
                signalRService.invoke('SendMessage', `${tempText}`, this.currentTopicId, signalRService.connectionId, e.type).then(() => {
                  let type = e.type == 'Image' ? `![${e.type}](${e.text})` : e.text;
                  let res = {
                    messageBot: `${type}`,
                    messageImage: null,
                    messageUser: null,
                    requestTime: this.formatResponseTime(),
                    responseTime: this.formatResponseTime(),
                    isRead: true,
                    switchShow: false,
                    contactAgentMode: true
                  }
                  this.messageForm.text = "";
                  this.messages.push(res)
                  this.selectedItem = 0;
                  this.scrollToBottom()
                });
              });

              if (text != "" && text != null && text != undefined) {
                signalRService.invoke('SendMessage', text, this.currentTopicId, signalRService.connectionId, "Text").then(() => {
                  let res = {
                    messageBot: text,
                    messageImage: null,
                    messageUser: null,
                    requestTime: this.formatResponseTime(),
                    responseTime: this.formatResponseTime(),
                    isRead: true,
                    switchShow: false,
                    adminReply: true,
                    contactAgentMode: true
                  }
                  this.messageForm.text = "";
                  this.previews = [];
                  this.messages.push(res)
                  this.selectedItem = 0;
                  this.scrollToBottom()
                });
              }
            }
            this.statusSendMessage = false;
          },
          (ex) => {
            this.$swal.fire({
              icon: 'alert',
              title: ex,
              showConfirmButton: false,
              timer: 1500,
            });
            this.statusSendMessage = false;
          }
        )
      } else {
        signalRService.invoke('SendMessage', text, this.currentTopicId, signalRService.connectionId, "Text").then(() => {
          let res = {
            messageBot: text,
            messageImage: null,
            messageUser: null,
            requestTime: this.formatResponseTime(),
            responseTime: this.formatResponseTime(),
            isRead: true,
            switchShow: false,
            adminReply: true,
            contactAgentMode: true
          }
          this.messageForm.text = "";
          this.previews = [];
          this.messages.push(res)
          this.statusSendMessage = false;
          this.selectedItem = 0;
          this.scrollToBottom()
        });
      }
    },
    toggleUserList() {
      this.showUserList = !this.showUserList;
      this.setResponsive(); // tabs row is v-if'd on showUserList (<1024)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          const ref = this.$refs.scrollContainer;
          const element = ref && ref.$el ? ref.$el : ref;
          if (!element || !element.scrollTo) {
            return;
          }
          element.classList?.add('vac-scroll-smooth');
          element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
          setTimeout(() => {
            element.classList?.remove('vac-scroll-smooth');
          }, 300);
        }, 50);
      });
    },
    shouldResetTopicList(status) {
      return status == "search" || status == "mounted" || status == "changeTab";
    },
    sortTopicListByUpdateDate(topicList) {
      return topicList.sort((a, b) => new Date(b.updateDate) - new Date(a.updateDate));
    },
    resetTopicState() {
      this.messages = [];
      this.user = "";
      this.totalchats = 0;
      this.profile = null;
      this.profileDrawer = false;
    },
    updateTopicList(topicList, status) {
      if (topicList.length == 0) {
        this.flagloadingTopic = false;
        console.warn("No data found");
      }

      if (topicList.length > 0 && status == "scroll") {
        this.topic = this.sortTopicListByUpdateDate(topicList.concat(this.topic));
        return;
      }

      if (!this.shouldResetTopicList(status)) {
        return;
      }

      this.topic = topicList;
      if (this.topic.length == 0) {
        this.resetTopicState();
        return;
      }

      this.totalchats = this.topic[0].totalCount;
    },
    selectFirstTopic(status) {
      if (!this.shouldResetTopicList(status) || this.topic.length == 0) {
        return;
      }

      const firstTopic = this.topic[0];
      const shouldReloadTopic = this.currentTopicId !== firstTopic.topicID || this.messages.length === 0;

      if (!shouldReloadTopic) {
        return;
      }

      this.selectedItem = 0;
      // Loading the first topic is only an initial display convenience. It must
      // not mark an unread conversation as read until the user explicitly clicks it.
      this.UserSelect(firstTopic.topicID, firstTopic.socialType, false)
    },
    handleGetTopicAllSuccess(dataResponse, status) {
      if (dataResponse.status !== 0) {
        return;
      }

      const topicList = dataResponse.data;
      this.updateTopicList(topicList, status);
      this.loadingTopic = false;
      this.selectFirstTopic(status);
    },
    GetTopicAll(status) {
      if (this.loadingTopic) {
        return;
      }
      if (status != "scroll") {
        this.loadingTopic = true;
        this.flagloadingTopic = true;
      }
      let adminReply = null;

      if (this.contactStatus === "agent") {
        adminReply = true;
      } else if (this.contactStatus === "bot") {
        adminReply = false;
      }
      const search = this.search;
      const SocialType = this.SocialType == 0 ? 'All' : this.SocialType;
      const lastTopicUpdateDate = this.topic.length > 0
        ? this.topic[this.topic.length - 1].updateDate
        : null;
      const updateDate =
        status == "changeTab" || status == "search" ? null : lastTopicUpdateDate;
      let take = (() => {
        switch (this.display.name.value) {
          case 'xs': return 10
          case 'sm': return 10
          case 'md': return 10
          case 'lg': return 10
          case 'xl': return 20
          case 'xxl': return 35
          default: return 45
        }
      })();
      let data = {
        // TopicID: TopicID,
        // USER_CHANNEL: self.$root.User_Id,
        // ID: Log_History_ID,
        Take: take,
        UpdateDate: updateDate,
        Search: search,
        socialType: SocialType,
        filter: {
          name: search,
          adminReply: adminReply
        }
      };

      this.$call.GetTopicAll(
        data,
        (dataResponse) => {
          this.handleGetTopicAllSuccess(dataResponse, status);
        }, (errorResource) => {
          console.error(errorResource);
          this.loadingTopic = false;
        }
      )
    },
    GetRoleId() {
      this.$call.GetRoleId(
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.roleId = dataResponse.data
          }

        }, (errorResource) => {
          console.error(errorResource);
        }
      )
    },
    async UserSelect(id, socialType, markAsRead = true) {
      this.previews = [];
      this.loadingMessage = true;
      this.StartupLoadingMessage = true;
      this.loadingUsername = true;
      const selectedUser = this.topic.find((topic) => topic.topicID === id);
      this.currentTopicId = id
      this.messages = []
      this.user = selectedUser?.displayName || 'Unknown ('+ socialType + ')';
      this.loadingUsername = false;
      this.queueTextareaResize();

      if (this.Axios_ControllerTopic == null) {
        this.Axios_ControllerTopic = new AbortController();
      } else {
        this.Axios_ControllerTopic.abort();
        this.Axios_ControllerTopic = null;
        await this.UserSelect(id, "", markAsRead);
        return;
      }
      this.flagGetTopic = true;
      this.LoadCustomerProfile(id);
      let data = {
        TopicID: this.currentTopicId,
        // USER_CHANNEL: self.$root.User_Id,
        ID: 0,
        Take: 5
      };
      let Config = {
        signal: this.Axios_ControllerTopic.signal
      }
      this.$call.GetHistoryMessage(
        data,
        Config,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            this.StartupLoadingMessage = false;
            this.Axios_ControllerTopic = null;
            this.flagGetTopic = false;
            const historyList = dataResponse.data.data;
            const IncomingMsg = JSON.stringify(historyList);
            const currentMsg = JSON.stringify(this.messages);
            if (this.currentTopicId > 0) {
              const activeTopic = this.topic.find(e => e.topicID == this.currentTopicId);
              if (activeTopic) {
                if (markAsRead && activeTopic.unread) {
                  this.MarkAsRead(this.currentTopicId);
                }
                if (markAsRead) {
                  activeTopic.unread = false;
                }
              }
            }
            if (currentMsg === IncomingMsg) {
              return IncomingMsg
            }
            else {
              if (historyList != null && historyList.length > 0) {
                historyList.forEach(history => {
                  this.messages.push(history)
                });
              }
              this.scrollToBottom()
            }
            this.loadingMessage = false;
            this.flagTopHistory = true;
            await signalRService.invoke('JoinChat', id, signalRService.connectionId);
          } else {
            this.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
            this.loadingMessage = false;
          }
        }, (errorResource) => {
          console.error(errorResource);
          this.loadingMessage = false;
        }
      )
    },
    GetHistoryMessage() {
      if (this.loadingMessage) {
        return;
      }
      this.loadingMessage = true
      const TopicID = this.currentTopicId;
      const Log_History_ID = this.Log_History_ID;
      const Log_History_Take = this.Log_History_Take;

      const ref = this.$refs.scrollContainer;
      const element = ref && ref.$el ? ref.$el : ref;
      const scrollPosition = element ? element.scrollHeight : 0;
      let data = {
        TopicID: TopicID,
        // USER_CHANNEL: self.$root.User_Id,
        ID: Log_History_ID,
        Take: Log_History_Take
      };

      this.Axios_ControllerTopic = new AbortController();
      let Config = {
        signal: this.Axios_ControllerTopic.signal
      }
      this.$call.GetHistoryMessage(
        data,
        Config,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            const historyList = dataResponse.data.data;
            if (historyList.length > 0) {
              this.messages = historyList.concat(this.messages);
            } else {
              this.flagTopHistory = false;
            }
            setTimeout(() => {
              if (element) element.scrollTop = element.scrollHeight - scrollPosition - 10;
            }, 1);

            this.loadingMessage = false;
          } else {
            this.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            })
            this.loadingMessage = false;
          }
          this.Axios_ControllerTopic = null
        }, (errorResource) => {
          console.error(errorResource);
          this.loadingMessage = false;
        }
      )
    },

    ChatScreScroll() {
      const ref = this.$refs.scrollContainer;
      const element = ref && ref.$el ? ref.$el : ref;
      if (!element) return;

      if (element.scrollTop <= element.scrollHeight &&
        element.scrollTop <= 0 &&
        this.loadingMessage === false &&
        this.flagTopHistory) {
        if (this.messages.length > 0) {
          this.Log_History_ID = this.messages[0].id;
          this.GetHistoryMessage();
        }
      }
    },
    TopicScroll(e) {
      const element = e.target;

      if (!element) return;

      if (Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 1 &&
        !this.loadingTopic &&
        this.flagloadingTopic) {
        if (this.topic.length > 0) {
          this.GetTopicAll("scroll");
        }
      }
    },
    async UserChange(id, socialType) {
      // ตรวจสอบสถานะฝารเชื่อมต่อฝ่อนส่งคำสั่ง
      if (!signalRService.connected) {
        try {
          await this.connectSignalR();
        } catch (err) {
          console.error("Disconnect:", err);
          return;
        }
      }

      // Join the new topic group first before disconnecting from old one
      await this.joinCurrentTopic();

      try {
        await signalRService.invoke("Disconnection", signalRService.connectionId, this.currentTopicId);
      } catch (err) {
        console.error(err);
      }

      // await signalRService.invoke("Disconnection", signalRService.connectionId, self.currentTopicId)
      await this.UserSelect(id, socialType);
    },
    MarkAsRead(topicId) {
      if (!topicId) return;
      if (this.readRequestsInFlight.has(topicId)) return;

      this.readRequestsInFlight.add(topicId);
      const targetTopic = this.topic.find(e => e.topicID == topicId);
      const wasUnread = targetTopic?.unread === true;
      if (targetTopic) {
        targetTopic.unread = false;
        if (wasUnread) {
          this.adjustLocalUnreadCount(targetTopic, -1);
        }
      }
      let id = { ID: topicId };
      this.$call.MarkAsRead(id,
        async (dataResponse) => {
          if (dataResponse.status === 0) {
            this.TopicUnread();
          } else if (targetTopic && wasUnread) {
            targetTopic.unread = true;
            this.TopicUnread();
            this.$swal.fire({
              icon: 'error',
              title: this.$t('_unableToMarkChatAsRead'),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          this.readRequestsInFlight.delete(topicId);
        },
        (errorResource) => {
          console.error("Error in MarkAsRead: ", errorResource);
          if (targetTopic && wasUnread) {
            targetTopic.unread = true;
          }
          this.TopicUnread();
          this.$swal.fire({
            icon: 'error',
            title: this.$t('_unableToMarkChatAsRead'),
            showConfirmButton: false,
            timer: 2000,
          });
          this.readRequestsInFlight.delete(topicId);
        });
    },

    formatResponseTime() {
      const date = new Date();
      const day = date.getDate().toString().padStart(2, '0');
      const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      const month = monthNames[date.getMonth()];

      // Get hours and minutes
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      // Format: "21 OCT 17:54"
      return `${day} ${month} ${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
:deep(#V_markDown) {
  display: grid;
}

:deep(#V_markDown p) {
  margin: 0;
  display: block;
}

:deep(#V_markDown table) {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0;
  color: #2b2b2b !important;
}

:deep(#V_markDown tr) {
  border-top: 1px solid #c6cbd1;
  background: #fff;
}

:deep(#V_markDown td,
  #V_markDown th) {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

:deep(#V_markDown table tr):nth-child(2n) {
  background: #d8d9da;
}

:deep(#V_markDown li code),
:deep(#V_markDown p code) {
  background-color: transparent;
  color: blue;
}

:deep(#V_markDown code.language-markdown),
:deep(#V_markDown pre code) {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff;
  border: 6px, double, white;
}

:deep(#V_markDown code) {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff;
}

:deep(#V_markDown pre code) {
  margin: 10px 0px;
}

:deep(#V_markDown img) {
  max-width: 100%;
  max-height: 320px
}

:deep(#V_markDown ul.contains-task-list li) {
  margin-top: -20px
}

:deep(#V_markDown br) {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%;
}

:deep(#V_markDown li) {
  margin-top: -1em;
}

:deep(#V_markDown li p) {

  margin-top: -22px;
}

:deep(#V_markDown li p strong) {
  margin-top: -22px;
  display: block;
}


:deep(#V_markDown ul) {
  margin-bottom: -20px;
}

:deep(#V_markDown ol li ul) {
  margin-bottom: -40px;
}

:deep(#V_markDown h1,
  #V_markDown h2,
  #V_markDown h3,
  #V_markDown h4,
  #V_markDown h5) {
  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

:deep(#V_markDown ol) {
  margin-bottom: -25px;
}

:deep(#V_markDown blockquote) {
  margin-top: -35px
}

:deep(#V_markDown .container) {
  margin-top: 0px;
}



.user-box {
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.view-height {
  height: var(--responsiveSizeH);
  max-height: calc(var(--responsiveSizeH) - 30px);
}

.scrollable {
  /* max-height: 400px; Adjust height as needed */
  overflow-y: auto;
}

.v-input .v-input__prepend-outer {
  margin: 0px !important;
  margin-top: 0px !important;
}

:deep(textarea#chat-compose-input) {
  max-height: 7rem;
  overflow: auto;
}

.message {
  border-radius: 15px;
}

.markdown-content :deep(p) {
  margin-bottom: 0px !important;
}


/* Chat input container styles */
.chat-input-container {
  padding: 16px;
  background: linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 24px 24px 0 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
}

/* File preview section */
.file-preview-section {
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.file-preview-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.file-preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 80px;
}

.file-preview-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.file-preview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.file-preview-image {
  border-radius: 10px;
}

.file-preview-overlay {
  position: absolute;
  top: -4px;
  right: -4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.file-preview-card:hover .file-preview-overlay {
  opacity: 1;
}

.file-remove-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3) !important;
}

.file-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.add-more-btn {
  width: 60px !important;
  height: 60px !important;
  border: 2px dashed #e0e0e0 !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.add-more-btn:hover {
  border-color: var(--v-primary-base) !important;
  background-color: rgba(var(--v-theme-primary), 0.04) !important;
}

/* Input wrapper */
.input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background: white;
  border-radius: 28px;
  padding: 8px;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

/* Action buttons */
.input-action-btn {
  flex-shrink: 0;
  color: #666 !important;
  transition: all 0.2s ease !important;
  border-radius: 20px !important;
}

.input-action-btn:hover {
  background-color: rgba(var(--v-theme-primary), 0.08) !important;
  color: var(--v-primary-base) !important;
  transform: scale(1.05);
}

.attachment-btn:hover {
  color: #2196F3 !important;
}

.emoji-btn:hover {
  color: #FF9800 !important;
}

/* Text input container */
.text-input-container {
  flex: 1;
  min-width: 0;
}

/* Input styles */
:deep(.chat-input .v-field) {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  border-radius: 20px !important;
}

:deep(.chat-input .v-field__field) {
  padding: 12px 16px !important;
}

:deep(.chat-input .v-field__outline) {
  display: none !important;
}

:deep(.chat-input textarea) {
  font-size: 16px !important;
  line-height: 1.5 !important;
  resize: none !important;
  max-height: 120px !important;
}

:deep(.chat-input .v-field__input) {
  min-height: 24px !important;
  padding: 0 !important;
  mask-image: none !important;
}

:deep(.chat-input .v-input__details) {
  display: none !important;
}

/* Input actions */
.input-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* Send button */
.send-btn {
  min-width: 48px !important;
  height: 48px !important;
  border-radius: 24px !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.3) !important;
  transition: all 0.2s ease !important;
}

.send-btn:not(.loading):not(:disabled) {
  animation: pulse 2s infinite;
}

.send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(var(--v-theme-primary), 0.4) !important;
}

.send-btn:disabled {
  opacity: 0.5 !important;
  box-shadow: none !important;
}

.send-btn.loading {
  animation: none;
}

/* Animations */
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .chat-input-container {
    padding: 12px;
    border-radius: 20px 20px 0 0;
  }

  .input-wrapper {
    gap: 8px;
    padding: 6px;
    border-radius: 24px;
  }

  .input-action-btn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
  }

  .send-btn {
    min-width: 44px !important;
    height: 44px !important;
    border-radius: 22px !important;
  }

  .file-preview-section {
    margin-bottom: 12px;
    padding: 8px;
  }

  .file-preview-grid {
    gap: 8px;
  }
}



/* ChatService input container styles */
.chatservice-input-container {
  padding: 0;
  position: relative;
}

/* ChatService file preview section */
.chatservice-file-preview-section {
  padding: 12px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 16px 16px 0px 0px;
  border: 1px solid #3859D0;
  border-bottom: none;
}

.chatservice-file-preview-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.chatservice-file-preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100px;
}

.chatservice-file-preview-card {
  position: relative;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.chatservice-file-preview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.chatservice-file-preview-image {
  border-radius: 10px;
}

.chatservice-file-preview-overlay {
  position: absolute;
  top: 5px;
  right: 5px;
}

.chatservice-file-remove-btn {
  background: rgba(0, 0, 0, 0.70) !important;
  color: white !important;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  opacity: 1;
}

.chatservice-file-name {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 10px;
  font-size: 12px;
  color: white;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.70);
  backdrop-filter: blur(3px);
  text-align: center;
  width: calc(100% - 16px);
  max-width: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  cursor: pointer;
  z-index: 2;
}

.chatservice-add-more-btn {
  width: 60px !important;
  height: 60px !important;
  border: 2px dashed #e0e0e0 !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.chatservice-add-more-btn:hover {
  border-color: var(--v-primary-base) !important;
  background-color: rgba(var(--v-theme-primary), 0.04) !important;
}

/* ChatService input wrapper */
.chatservice-input-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 16px;
  border: 1px solid #C9C9C9;
  transition: all 0.2s ease;
}

.chatservice-input-wrapper:focus-within {
  box-shadow:
    0 8px 32px rgba(var(--v-theme-primary), 0.15),
    0 2px 8px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border-color: rgba(var(--v-theme-primary), 0.3);
}
.chatservice-input-wrapper--has-files{
  border: 1px solid #3859D0;
  border-top: none;
  border-radius: 0 0 16px 16px;
}
/* ChatService action buttons */
.chatservice-input-action-btn {
  flex-shrink: 0;
  color: #666 !important;
  transition: all 0.2s ease !important;
  border-radius: 20px !important;
}

.chatservice-input-action-btn:hover {
  background-color: #FDE4DF !important;
  color: var(--v-primary-base) !important;
  transform: scale(1.05);
}

.chatservice-attachment-btn:hover {
  color: #2196F3 !important;
}

.chatservice-emoji-btn:hover {
  color: #FF9800 !important;
}

/* ChatService text input container */
.chatservice-text-input-container {
  flex: 1;
  min-width: 0;
}

/* ChatService input styles */
:deep(.chatservice-chat-input .v-field) {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  border-radius: 20px !important;
}

:deep(.chatservice-chat-input .v-field__field) {
  padding: 12px 16px !important;
}

:deep(.chatservice-chat-input .v-field__outline) {
  display: none !important;
}

:deep(.chatservice-chat-input textarea) {
  font-size: 16px !important;
  line-height: 1.5 !important;
  resize: none !important;
  max-height: 120px !important;
}

:deep(.chatservice-chat-input .v-field__input) {
  min-height: 24px !important;
  padding: 0 !important;
  mask-image: none !important;
}

:deep(.chatservice-chat-input .v-input__details) {
  display: none !important;
}

/* ChatService input actions */
.chatservice-input-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* ChatService send button */
.chatservice-send-btn {
  background: transparent;
  height: 48px !important;
  max-width: 48px!important;
  border-radius: 50px !important;
  transition: all 0.2s ease !important;
}

.chatservice-send-btn:not(.chatservice-loading):not(:disabled) {
  animation: chatservice-pulse 2s infinite;
}

.chatservice-send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  background: #FDE4DF;
}

.chatservice-send-btn:disabled {
  opacity: 0.5 !important;
  box-shadow: none !important;
}

.chatservice-send-btn.chatservice-loading {
  animation: none;
}

/* ChatService animations */
@keyframes chatservice-pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}

:deep(.mdi-spin) {
  animation: chatservice-spin 1s linear infinite;
}

@keyframes chatservice-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* ChatService responsive design */
@media (max-width: 768px) {
  .chatservice-input-container {
    padding: 12px;
    border-radius: 20px 20px 0 0;
  }

  .chatservice-input-wrapper {
    gap: 8px;
    padding: 6px;
    border-radius: 12px;
  }

  .chatservice-input-action-btn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
  }

  .chatservice-send-btn {
    min-width: 44px !important;
    height: 44px !important;
    border-radius: 22px !important;
  }

  .chatservice-file-preview-section {
    padding: 8px;
  }

  .chatservice-file-preview-grid {
    gap: 8px;
  }
}

.chatservice-topic-list-container {
  height: 100% !important;
  min-height: 400px !important;
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.chatservice-topic-list-group {
  height: 100% !important;
  flex: 1 1 auto !important;
  overflow: hidden !important;
}

.chatservice-topic-virtual-scroll {
  background: transparent;
  height: 100% !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  border-radius: 12px;
}

/* แก้ไข v-virtual-scroll internal container */
:deep(.chatservice-topic-virtual-scroll .v-virtual-scroll__container) {
  overflow-y: auto !important;
  height: 100% !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-primary), 0.3) rgba(0, 0, 0, 0.04);
  border-radius: 12px;
}

/* เพิ่ม scrollbar styles สำหรับ webkit browsers */
:deep(.chatservice-topic-virtual-scroll .v-virtual-scroll__container::-webkit-scrollbar) {
  width: 12px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
}

/* Fix skeleton loader container */
:deep(.v-skeleton-loader.fill-height) {
  min-height: 0 !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

.chatservice-topic-item-wrapper {
  background: transparent;
}

.chatservice-topic-list-item {
  border-radius: 10px;
  margin-bottom: 2px;
  transition: background 0.15s;
  cursor: pointer;
  min-height: 75px;
  padding: 8px 12px;
}

.chatservice-topic-list-item:hover {
  background: #E7EBFF;
}

.chatservice-topic-badge {
  margin-right: 8px;
}

.chatservice-topic-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px!important;
}

.chatservice-topic-title {
  font-weight: 400;
  font-size: 15px;
  color: #000;
}

.chatservice-topic-subtitle {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.chatservice-topic-divider {
  margin: 0 0 0 60px;
  border-color: #eee;
}

/* Responsive */
@media (max-width: 768px) {
  .chatservice-topic-list-item {
    padding: 6px 6px;
    min-height: 56px;
  }

  .chatservice-topic-title {
    font-size: 14px;
  }

  .chatservice-topic-subtitle {
    font-size: 12px;
    max-width: 100px;
  }
}

.chatservice-switch-wrapper {
  transform: scale(1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 90px;
}

.chatservice-topic-switch {
  margin-left: 0;
  padding: 0 2px;
  --v-switch-thumb-size: 18px;
  --v-switch-track-width: 34px;
  --v-switch-track-height: 18px;
  --v-switch-track-opacity: 0.15;
  --v-switch-track-border-radius: 9px;
}
:deep(.chatservice-topic-switch .v-input__control) {
  width: auto;
}
:deep(.chatservice-topic-switch .v-switch__track,
.chatservice-topic-switch .v-switch__thumb) {
  display: none !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
}
:deep(.chatservice-topic-switch.chatservice-switch-label-left .v-input__control) {
  flex-direction: row;
  justify-content: center;
}
:deep(.chatservice-topic-switch .v-input__details) {
    display: none;
}
:deep(.chatservice-topic-switch .v-selection-control__input) {
  min-width: 34px !important;
  display: none !important;
}

.chatservice-switch-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1px;
  padding: 5px 10px;
  border-radius: 50px;
  margin: 0;
  transition: all 0.3s ease-in-out;
  cursor: pointer; 
}

.chatservice-switch-label-left {
  flex-direction: row-reverse !important;
  justify-content: flex-end !important;
}

:deep(.chatservice-switch-label-left .v-selection-control__wrapper) {
  order: 2;
}

:deep(.chatservice-switch-label-left .v-label) {
  order: 1;
  margin-right: 8px;
  margin-left: 0;
  display: flex;
  align-items: center;
}

.chatservice-switch-label.is-admin {
  background-color: #C30000;
  color: white;
  flex-direction: row-reverse;
  transition: all 0.3s ease-in-out;
}
.is-adminimg {
  left: 10px!important;
}
.is-botimg {
  right: 5px!important;
}

.chatservice-switch-label.is-bot {
  background-color: #A6A6A6;
  color: #3b3b3b;
}
.chatservice-switch-label.is-admin .v-icon {
    background-color: white !important; /* Force white background */
    color: #cc0000 !important; /* Make the icon itself red */
    border-radius: 50%;
    padding: 3px; /* Adjust padding to make the circle size right */
    width: 1.5em; /* Ensure good circle size */
    height: 1.5em;
    display: flex; /* For centering the icon */
    align-items: center;
    justify-content: center;
}
.chatservice-switch-label.is-bot .v-icon {
    background-color: transparent !important;
}
@media (max-width: 768px) {
  .chatservice-switch-label {
    font-size: 12px;
  }

  .chatservice-switch-wrapper {
    min-width: 70px;
  }
}

/* ChatService Custom Scrollbar */
.chatservice-scrollable {
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #646464;
}

/* Webkit Scrollbar (Chrome, Safari, Edge) */
.chatservice-scrollable::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.chatservice-scrollable::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  margin: 4px 0;
}

.chatservice-scrollable::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.3);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.chatservice-scrollable::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-primary), 0.5);
  transform: scale(1.1);
}

.chatservice-scrollable::-webkit-scrollbar-thumb:active {
  background: rgba(var(--v-theme-primary), 0.7);
}

.chatservice-scrollable::-webkit-scrollbar-corner {
  background: transparent;
}

/* Virtual Scroll Container Override */
:deep(.chatservice-scrollable .v-virtual-scroll__container) {
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-primary), 0.3) transparent;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar) {
  width: 8px;
  height: 8px;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  margin: 4px 0;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-thumb) {
  background: rgba(var(--v-theme-primary), 0.3);
  border-radius: 4px;
  transition: all 0.2s ease;
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-thumb:hover) {
  background: rgba(var(--v-theme-primary), 0.5);
  transform: scale(1.1);
}

:deep(.chatservice-scrollable .v-virtual-scroll__container::-webkit-scrollbar-thumb:active) {
  background: rgba(var(--v-theme-primary), 0.7);
}

.savebtn {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%);
  color: white !important;
  width: 100%;
  border-radius: 12px;
  height: 40px;
  text-transform: none !important;
}
.optioncard{
  width: 200px;
  border-radius: 12px!important;
}
:deep(.optioncard .v-input__details){
  display: none !important;
}
.maxtoggle{
  border-radius: 50px;
  min-width: 40px!important;
}
.maxtoggle:hover {
  background: #FDE4DF;
}
.optionbtn:hover {
  background: #FDE4DF;
}
.chatservice-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-clear-btn {
  min-width: 0 !important;
  height: 34px !important;
  padding: 0 14px !important;
  border-radius: 999px !important;
  border: 1px solid rgba(195, 46, 14, 0.18) !important;
  background: #FFF5F2 !important;
  color: #C32E0E !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  box-shadow: none !important;
}

.notification-clear-btn:hover {
  background: #FDE4DF !important;
}

.notification-clear-btn:disabled {
  opacity: 0.55 !important;
}
/* System message styles */
.system-message-container {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.system-message-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.system-message-text {
  color:#646464;
  font-family: var(--Poppins-Font, Poppins);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.divider{
  width: 320px;
  height: 1px!important;
  border: 1px solid rgba(148, 154, 168, 0.50);;
}
.message-media{
  width: fit-content;
  float: right;
  min-height: 35px;
  max-width: 80%;
  margin-top: 2px;
  margin-right: 6px;
  color: #fff;
  /* border: 1px solid #3859D0;  use color from config theme*/
  padding: 1px!important;
  border-radius: 13px;
}
.message-text{
  line-break: anywhere;
  border-radius: 15px;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
  width: fit-content;
  float: right;
  min-height: 35px;
  max-width: 80%;
  margin-top: 2px;
  margin-right: 6px;
  background-color: #3859D0;
  color: #ffffff;
  padding: 8px;
}
.chatservice-profile-sheet {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}
</style>
